import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import CustomerOrderCard from "../../shares/CustomerOrderCard";
import useFetch from "../../../../context/useFetch";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { useSetting } from "../../../../context/SettingContext";
// import { defaultRingSize } from "../../../../constants/constants";


const OrderDetails = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const {defaultRingSize} = useSetting()
  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });

  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));

  const update_nums = (ind, nValue) => {
    let beforeNums = [...nums];
    beforeNums[ind] = nValue;
    setNums(beforeNums);
  };

  const getCurrentOerdersDetailApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/user_get_order_item_detail_from_order`,
    trigger: false,
    setter: setCurrentOerdersDetail,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCurrentOerdersDetailApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex items-center justify-center">
            <span className="show-label">
              کد سفارش:{" "}
              <span className="show-value">
                {currentOerdersDetail.detail?.unique_id}
              </span>
            </span>
          </div>
          <div className="border-b border-dashed my-2"></div>
          <SizeTextGrid have5Col />
          <div className="md:max-h-96 md:overflow-scroll md:px-2 md:mb-2">
            {currentOerdersDetail.results.map((item, index) => {
              return [
                <CustomerOrderCard item={item} disabled>
                  <OrderCardLeftPartTemplate
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={item}
                    ringIndex={index}
                    adminCantEdit
                    showAcceptOrRejectFromAdmin
                    adminNeedColor
                    adminDidntNeedCustomerRequestNum
                  />
                </CustomerOrderCard>,
              ];
            })}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
